"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.timePickerWidth = exports.datePickerWidth = exports.datePickerHeight = exports.timeFormat = exports.dateFormat = void 0;
var dateFormat = 'MM/dd/yyyy hh:mm aa';
exports.dateFormat = dateFormat;
var timeFormat = 'hh:mm aa';
exports.timeFormat = timeFormat;
var datePickerHeight = '40px';
exports.datePickerHeight = datePickerHeight;
var datePickerWidth = '512px';
exports.datePickerWidth = datePickerWidth;
var timePickerWidth = '200px';
exports.timePickerWidth = timePickerWidth;
var classes = {
  stepperMainContainer: 'policy-generic-conditions-tab-main-container',
  addPolicyFieldWrapper: 'sm-add-policy-field-wrapper',
  formNameLoaderWrapper: 'sm-form-name-loader-wrapper',
  formNameCheckLoader: 'sm-form-name-check-loader',
  addPolicyFieldValueWrapper: 'sm-add-policy-field-value-wrapper',
  fieldsGroupWrapper: 'sm-fields-group-wrapper',
  horizontalField: 'sm-horizontal-field',
  errorLabel: 'bds-autocomplete-error-message'
};
exports.classes = classes;